import { SessionType } from "@src/modules/interface";
import { useSelector } from "react-redux";

export function useFacilityTimeZone() {
  const { profile } = useSelector((state: SessionType) => state.session);
  return profile?.tmz;
}
